import React, { useState, useEffect } from "react";
import { navigate } from "gatsby"
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { ReferenciaPlantillaContenido } from "../../../interfaces/ReferenciaPlantillaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Slider from "react-slick";
import TitleSection from "../title-section";
import MentorsCard from "../../atoms/mentors-card/mentorsCard";
import equisCirculo from "../../../../src/assets/images/icons/x.svg";
import PreviousArrowButton from "../../atoms/previous-arrow-button/previousArrowButton";
import NextArrowButton from "../../atoms/next-arrow-button/nextArrowButton";

import "./carouselMentors.scss"
import "../../organisms/benefits-carousel-mpc/BenefitsCarouselMpc.scss"
import "../number-steps/numberSteps.scss"

const CarouselMentors = ({tituloGeneral, referenciaPlantillaContenido, tituloBoton, redireccionBoton} : ReferenciaContenido) => {
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [detailCardInfo, setDetailCardInfo] = useState<ReferenciaPlantillaContenido>();
    const [randomArray, setRandomArray] = useState<Array<number>>([]);
    const slidesToShow = referenciaPlantillaContenido.length >= 3 ? 3 : referenciaPlantillaContenido.length;
    const CarouselProps = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: slidesToShow,
        arrows: false,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
              breakpoint: 1330,
              settings: {
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1
              }
            }
          ]
    };

    const goToNext = () => {
        if (sliderIndex < referenciaPlantillaContenido.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < referenciaPlantillaContenido.length - 3;

    const getModalInformation = (cardInfo : ReferenciaPlantillaContenido ) : void => {
        setIsOpenModal(true);
        setDetailCardInfo(cardInfo);
    };

    const handleClick = () => {
        navigate(redireccionBoton);
    }

    useEffect(() => {
        const numbers: Set<number> = new Set();
        const randomNumbers: number[] = [];

        // Si hay 2 o menos elementos, simplemente usa sus índices
        if (referenciaPlantillaContenido.length <= 2) {
            for (let i = 0; i < referenciaPlantillaContenido.length; i++) {
            numbers.add(i);
            }
        } else {
            while (numbers.size < 7 && numbers.size < referenciaPlantillaContenido.length) {
            const randomNumber: number = Math.floor(Math.random() * referenciaPlantillaContenido.length);
            numbers.add(randomNumber);
            }
        }

        numbers.forEach(number => randomNumbers.push(number));
        setRandomArray(randomNumbers);
    }, []);

    return (
        <>
            <section className="m-carousel-mentors">
                <div className="m-carousel-mentors__title-container">
                    <TitleSection title={tituloGeneral} />
                    {window.innerWidth >= 768 && randomArray.length > 3 &&
                    <div className="arrows-slider">
                        <PreviousArrowButton canGoPrev={isActiveBack()} onClick={goToBack}/>
                        <NextArrowButton canGoNext={isActiveNext()} onClick={goToNext}/>
                    </div>}
                </div>
                {
                  randomArray.length && 
                  <Slider
                     ref={(c) => {
                           setSlider(c);
                     }}
                     {...CarouselProps}
                  > 
                     {referenciaPlantillaContenido.map((cardInfo, index) => 
                           {
                              if (randomArray && randomArray.includes(index)) {
                                 return (
                                       <MentorsCard
                                          name={cardInfo.tituloBanner}
                                          description={documentToReactComponents(cardInfo.descripcion.json)}
                                          location={cardInfo.tituloDescripcion}
                                          imgUrl={cardInfo.imagenPerfil?.file?.url}
                                          ctaAction={getModalInformation}
                                          ctaInfo={cardInfo}
                                       />
                                 );
                              } else {
                                 return null;
                              }
                           }
                     )}
                  </Slider> 
               }
            { tituloBoton && <button className="m-carousel-mentors__button" onClick={handleClick}>{tituloBoton}</button>}
            </section>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <div className="m-carousel-mentors__modal-content">
                        <button className="m-carousel-mentors__modal-close" onClick={() => setIsOpenModal(false)}>
                                <img className="m-carousel-mentors__modal-close-img" src={equisCirculo} alt="icono x"/>
                        </button>
                        <img src={detailCardInfo?.imagenPerfil.file.url} className="m-carousel-mentors__modal-img"/>
                        <div className="m-carousel-mentors__modal-container">
                            <div className="m-carousel-mentors__modal-name">
                                <span className="m-carousel-mentors__name">{detailCardInfo?.tituloBanner}</span>
                                <span className="m-carousel-mentors__location">{`Mentor - ${detailCardInfo?.tituloDescripcion}`}</span>
                            </div>
                            {documentToReactComponents(detailCardInfo?.descripcion?.json)}
                            <div className="m-carousel-mentors__skills">
                                <span className="m-carousel-mentors__skills-title">Habilidades destacadas:</span>
                                <span className="m-carousel-mentors__skills-description">{detailCardInfo?.tipoTitulo}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CarouselMentors;
